/* eslint-disable react-hooks/exhaustive-deps */
import * as L from 'leaflet';
import { useCallback, useEffect, useState } from "react";
import {
  defaultMapConfig,
  useMapConfig,
} from '../../../../../../../components/SubjectsMap/helper';

const locationIcon = '/assets/images/dashboard/map-icons/amp.svg';
const locationIconFocused = '/assets/images/dashboard/map-icons/amp_focused.svg';

const useAmpsMap = ({ data, container }) => {
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();
  const [mapRef, setMapRef] = useState();
  const [markers, setMarkers] = useState([]);
  const [activeMarker, setActiveMaker] = useState(null);
  const [activeMarkerRef, setActiveMakerRef] = useState(null);

  const createInstance = () => {
    if (container.current) {
      var c = L.DomUtil.get(document.getElementById(container.current));
      if (c != null) {
        c._leaflet_id = null;
      }
      const map = L.map(container.current, {
        ...defaultMapConfig,
        center: [0, 0],
        zoom: 3,
      });
      L.control.scale().addTo(map);
      L.tileLayer(TILE_LAYER_URL, { access_token: MAP_TOKEN }).addTo(map);
      return map;
    }
  };

  useEffect(() => {
    if (!mapRef) {
      setMapRef(createInstance());
    }
  }, []);

  const removeMarkers = useCallback(() => {
    mapRef.eachLayer((layer) => {
      if (markers.find((m) => m._leaflet_id === layer._leaflet_id)) {
        mapRef.removeLayer(layer);
      }
    });
  }, [mapRef, markers]);

  const onCloseSider = useCallback(() => {
    setActiveMaker(null)

    activeMarkerRef.setIcon(L.icon({
      iconUrl: locationIcon,
      iconSize: [36, 36],
    }))

    setActiveMakerRef(null);
  }, [activeMarkerRef]);

  useEffect(() => {
    if (activeMarkerRef) {
      activeMarkerRef.setIcon(L.icon({
        iconUrl: locationIconFocused,
        iconSize: [36, 36],
      }));
    }

    return () => {
      if (activeMarkerRef) {
        activeMarkerRef.setIcon(L.icon({
          iconUrl: locationIcon,
          iconSize: [36, 36],
        }));
      }
    }
  }, [activeMarkerRef]);

  useEffect(() => {
    if (mapRef) {
      removeMarkers();

      const _markers = [];
      const _bounds = [];

      data.forEach((amp) => {
        const coords = L.latLng(amp.coordinates.lat, amp.coordinates.lng)
        const marker = L.marker(coords, {
          icon: L.icon({
            iconUrl: locationIcon,
            iconSize: [36, 36],
          }),
          zIndexOffset: 100,
        })
          .addTo(mapRef)

        _markers.push(marker);

        marker.addEventListener('click', () => {
          setActiveMaker(amp.id);
          setActiveMakerRef(marker);
        })

        _bounds.push({
          lat: amp.coordinates.lat,
          lng: amp.coordinates.lng,
        });
      })

      if (_bounds.length) {
        mapRef.fitBounds(_bounds, { padding: [50, 50] });
      }

      setMarkers(_markers);
    }
  }, [data, mapRef]);

  return { onCloseSider, activeMarker };
};

export default useAmpsMap;
